export enum IntegrationBridgeType {

    ANDROID = 0,
    IOS = 2,
    HTML5 = 3,
    DUMMY = 4,
    ELECTRON = 5,
    REACT_NATIVE = 6,
}
